import { types } from './actions';

const initialState = {
  isCheckoutSettingsUpdating: false,
  allowLocalPickup: true,
};

const reducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case types.CHECKOUT_SETTINGS_FETCH_SUCCESS:
      return {
        ...state,
        allowLocalPickup: payload.allowLocalPickup,
        sendOrderConfirmationEmails: payload.sendOrderConfirmationEmails,
      };
    case types.CHECKOUT_SETTINGS_UPDATE_REQUEST:
      return {
        ...state,
        isCheckoutSettingsUpdating: true,
      };
    case types.CHECKOUT_SETTINGS_UPDATE_SUCCESS:
      return {
        ...state,
        allowLocalPickup: payload.allowLocalPickup,
        sendOrderConfirmationEmails: payload.sendOrderConfirmationEmails,
        isCheckoutSettingsUpdating: false,
      };
    case types.CHECKOUT_SETTINGS_UPDATE_ERROR:
      return {
        ...state,
        isCheckoutSettingsUpdating: false,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) =>
  state.modules.settings.digitalQuote.checkoutSettings;

export const getIsCheckoutSettingsUpdating = (state) =>
  getScope(state).isCheckoutSettingsUpdating;

export const getAllowLocalPickup = (state) => getScope(state).allowLocalPickup;
export const getSendOrderConfirmationEmails = (state) =>
  getScope(state).sendOrderConfirmationEmails;
